import type { I18nDefinition } from '@backmarket/nuxt-module-i18n/types'

export default {
  plan: {
    id: 'product_page_google_shopping_inline_plan_price',
    defaultMessage: '+ {price}/mois',
  },
} as Record<string, I18nDefinition>
